export default "__VITE_ASSET__DHLYPFEv__"